export default __webpack_public_path__ + "b0b07c86e5ffa071d9ec6145b47d9672.png";